/**
 * Staff UI helpers for Task writes that must go through lifecycle bots.
 * Patient portal sessions must not call these for new inventory bots until
 * AccessPolicy review adds those Bot identifiers to patientPortalBotExecuteAccess.
 */
import { ContentType } from '@medplum/core';
import type { MedplumClient } from '@medplum/core';
import type { Task } from '@medplum/fhirtypes';

export const TASK_MUTATION_BOT = {
  system: 'https://unify.health/bots',
  value: 'task-mutation',
} as const;

export const PORTAL_TASK_LIFECYCLE_BOT = {
  system: 'https://unify.health/bots',
  value: 'portal-task-lifecycle',
} as const;

export async function executeTaskMutation<T = Task>(
  medplum: MedplumClient,
  input: Record<string, unknown>,
): Promise<T> {
  return medplum.executeBot(TASK_MUTATION_BOT, input, ContentType.JSON) as Promise<T>;
}

export async function executePortalTaskLifecycle<T = Task>(
  medplum: MedplumClient,
  input: Record<string, unknown>,
): Promise<T> {
  return medplum.executeBot(PORTAL_TASK_LIFECYCLE_BOT, input, ContentType.JSON) as Promise<T>;
}